import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export const BELSOFT_SUPPORT_WHATSAPP =
  "https://wa.me/2347079010708?text=" +
  encodeURIComponent("Hi Belsoft Systems, I need support.");

const INITIAL_MESSAGES = [
  {
    id: "welcome",
    sender: "bot",
    content: "Hello! My name is Bela. How can I help you today?",
  },
];

const BelaChatContext = createContext(null);

export function BelaChatProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState(INITIAL_MESSAGES);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const openChatBot = useCallback(() => setIsOpen(true), []);
  const closeChatBot = useCallback(() => setIsOpen(false), []);

  const sendMessage = useCallback(() => {
    const trimmed = input.trim();
    if (!trimmed) return;

    setMessages((prev) => [...prev, { id: `user-${Date.now()}`, sender: "user", content: trimmed }]);
    setInput("");
    setIsTyping(true);

    window.setTimeout(() => {
      setIsTyping(false);
      setMessages((prev) => [
        ...prev,
        {
          id: `bot-${Date.now()}`,
          sender: "bot",
          content:
            "Thanks for reaching out. Our team is ready to help on WhatsApp.",
          showWhatsApp: true,
        },
      ]);
    }, 1000);
  }, [input]);

  const value = useMemo(
    () => ({
      isOpen,
      messages,
      input,
      isTyping,
      whatsappUrl: BELSOFT_SUPPORT_WHATSAPP,
      setInput,
      openChatBot,
      closeChatBot,
      sendMessage,
    }),
    [isOpen, messages, input, isTyping, openChatBot, closeChatBot, sendMessage]
  );

  return (
    <BelaChatContext.Provider value={value}>{children}</BelaChatContext.Provider>
  );
}

export function useBelaChat() {
  const ctx = useContext(BelaChatContext);
  if (!ctx) {
    throw new Error("useBelaChat must be used within BelaChatProvider");
  }
  return ctx;
}
